import { Component } from "react";
import Footer from "../components/base/Footer";
import Header from "../components/base/Header";
import Content from "../components/marketing/Content";
import MainContent from "../components/marketing/MainContent";
import Mission from "../components/marketing/Mission";
import SecondaryContent from "../components/marketing/SecondaryContent";

export default class Home extends Component {
  render() {
    return (
      <div className="bg-white">
        <Header page="Home" />
        <MainContent />
        <Mission />
        <SecondaryContent />
        <Content />
        <Footer />
      </div>
    );
  }
}
